/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createDecorator } from '../../instantiation/common/instantiation.js';
export class Progress {
    constructor(callback) {
        this.callback = callback;
    }
    report(item) {
        this._value = item;
        this.callback(this._value);
    }
}
Progress.None = Object.freeze({ report() { } });
export const IEditorProgressService = createDecorator('editorProgressService');



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/platform/progress/common/progress.js
// module id = null
// module chunks = 